import React, { useEffect, useState } from 'react'
import { Select } from 'antd';
import { Option } from 'antd/es/mentions';
import { GetAll_SubPeriod_Api } from '../../API/SubPeriodApi';
// ======================================================================
export const SubPeriodCombo = ({
    setLoading,
    showMessage,
    periodId,
    onChange
}) => {
    // ======================================================================
    const [subPeriods, setSubPeriods] = useState([]);
    // ======================================================================
    useEffect(() => {
        loadData();
    }, [periodId]);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_SubPeriod_Api(periodId);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setSubPeriods(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            // showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // ======================================================================
    const handleChange = (value) => {
        if (onChange) onChange(value);
    };
    // ======================================================================
    return (
        <Select
            style={{ width: '100%' }}
            placeholder={"همه زیر دوره ها"}
            onChange={handleChange}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
            }
        >
            <Option value={null}>
            {"همه زیر دوره ها"}
            </Option>
            {
                subPeriods.map((subPeriod, key) => (
                    <Option key={key} value={subPeriod.id}>
                        {subPeriod.title}
                    </Option>
                ))
            }
        </Select >
    )
}

